export default [
  {
    id: 'fsingle-id',
    value: 'single',
    tracking: 'ga-search-form-toggle-single-bed',
    icon: 'single-bed'
  },
  {
    id: 'fdouble-id',
    value: 'double',
    tracking: 'ga-search-form-toggle-double-bed',
    icon: 'double-bed'
  },
  {
    id: 'ftwin-id',
    value: 'twin',
    label: '2',
    tracking: 'ga-search-form-toggle-twin-beds',
    icon: 'single-bed'
  },
  {
    id: 'fbunk-id',
    value: 'bunk',
    tracking: 'ga-search-form-toggle-bunk-beds',
    icon: 'bunk-bed'
  }
];
